import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';

import { Config } from '../../config/config';
import { VnptHttpService } from '../services/vnpt-http.service';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class SYSHdsdService {
    controller: string = 'SYSHdsd';
    constructor(private http: Http) { }

    GetListItems() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/GetListItems', JSON.stringify({}), { headers: headers }).map(resp => resp.json());
    }

    CheckRole(username:string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {username: username};
        return this.http.post(Config.apiUrl + this.controller + '/CheckRole', JSON.stringify(data),{ headers: headers }).map(resp => resp.json());
    }

    GetItem(ids:string) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = ids;
        return this.http.post(Config.apiUrl + this.controller + '/GetItem', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }

    DownloadFile(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller + '/DownloadFile?Ids=' + item.Ids, { headers: headers, responseType: ResponseContentType.ArrayBuffer }).map(
            resp => resp.arrayBuffer());
    }

    SaveUploadFile(fileList: FileList, item){
        let headers = new Headers();
        //headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let options = new RequestOptions({ headers: headers });
        let formData:FormData = new FormData();
        formData.append('SaveUploadFile', fileList[0], fileList[0].name);
        formData.append('Id', item.Id);
        formData.append('Ids', item.Ids);
        formData.append('Ten', item.Ten);
        formData.append('Loai', item.Loai);
        return this.http.post(Config.apiUrl + this.controller + '/SaveUploadFile', formData, { headers: headers }).map(resp => resp.json());
    }

    SaveNoUploadFile(item) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller + '/SaveNoUploadFile', JSON.stringify(item), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/sys-hdsd/sys-hdsd.service.ts